<div class="flex w-full h-full p-6 gap-6 bg-surface-50 overflow-auto">
  <div class="flex-1 min-w-96 flex flex-col">
    <p-card>
      <div class="w-fit h-fit bg-white rounded-lg mb-4">
        <p-button outlined severity="secondary" size="small" icon="fa-regular fa-file-export" label="Compliance TAs Export"
                  data-testid="compliance-export-button" [loading]="exporting()" (onClick)="exportComplianceTas()"></p-button>
      </div>

      <p-tabs [(value)]="tabOption" lazy (valueChange)="tabChanged()">
        <div class="bg-white rounded-t-lg w-fit max-w-full min-w-0">
          <p-tablist class="w-fit max-w-full min-w-0">
            <p-tab value="overpaid" data-testid="compliance-tab-overpaid">
              <div class="flex items-center gap-2">
                <span class="text-nowrap">Overpaid Submissions</span>
                @if ((counts().overpaid ?? 0) > 0) {
                  <p-badge [value]="counts().overpaid" severity="danger" badgeSize="small"></p-badge>
                }
              </div>
            </p-tab>
            <p-tab value="dayTrips" data-testid="compliance-tab-day-trips">
              <div class="flex items-center gap-2">
                <span class="text-nowrap">Day Trip Payments</span>
                @if ((counts().dayTrips ?? 0) > 0) {
                  <p-badge [value]="counts().dayTrips" severity="danger" badgeSize="small"></p-badge>
                }
              </div>
            </p-tab>
            @if (permissionService.canViewSearch()) {
              <p-tab value="allSubmissions">Search All Submissions</p-tab>
            }
          </p-tablist>
        </div>

        <p-tabpanels class="rounded-b-lg rounded-tr-lg">
          <p-tabpanel value="overpaid">
            <div scrollHeight [bottomPadding]="60" class="flex flex-col gap-4 overflow-auto">
              @if (availableTaList().length > 0) {
                <div class="flex gap-2 items-center">
                  <input type="text"
                       pInputText
                       [(ngModel)]="searchStr"
                       class="w-1/2"
                       pSize="small"
                       placeholder="Type to filter by TA number, project code, status or staff..."
                  />
                  <div class="bg-white rounded-lg">
                    <p-button outlined severity="secondary"
                          size="small"
                          (onClick)="searchStr.set('')">Clear</p-button>
                  </div>
                </div>

                <p-table [value]="filteredTaList()"
                     stripedRows
                     [tableStyle]="{'min-width': '40rem'}"
                     sortField="taNumber"
                     [sortOrder]="-1"
                     class="ta-list ta-list-dense border-[1px] border-surface-300 rounded-lg">
                  <ng-template #header>
                    <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed']">
                      <th class="rounded-tl-lg ta-col-prepaid"></th>
                      <th class="ta-col-attachment"></th>
                      <th>TA Number</th>
                      <th pSortableColumn="startDate" style="align-items: center">
                        <div class="flex items-center gap-2">
                          Travel Date
                          <p-sortIcon field="startDate" />
                        </div>
                      </th>
                      <th>Status</th>
                      <th>Primary Traveller</th>
                      <th>No. of Travellers</th>
                      <th>Project Code</th>
                      <th style="padding-left: 4px; padding-right: 4px; text-align: center;">Total TA Value (Acquitted)</th>
                      <th style="padding-left: 4px; padding-right: 4px; text-align: center;">Overpaid Amount</th>
                      <th class="ta-col-actions">Actions</th>
                      <th class="rounded-tr-lg ta-col-comments"></th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-taSubmission let-rowIndex="rowIndex">
                    <tr class="text-xs font-normal font-['Roboto_Condensed'] hover:cursor-pointer" (click)="setSelectedTa(taSubmission)">
                      <td class="ta-col-prepaid" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-bl-lg' : (rowIndex === availableTaList().length - 1)}">
                        <prepaid-indicator [taDetails]="taSubmission"></prepaid-indicator>
                      </td>
                      <td class="ta-col-attachment" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
                        <attachment-indicator [taDetails]="taSubmission"></attachment-indicator>
                      </td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
                        <button class="text-primary-500 hover:underline font-semibold cursor-pointer" (click)="viewTaSubmission(taSubmission)">
                          {{taSubmission.taNumber}}
                        </button>
                      </td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.startDate | date:'dd/MM/yy'}}</td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
                        <p-chip>
                          <div class="whitespace-nowrap">{{toTAStatusText(taSubmission.status)}}</div>
                        </p-chip>
                      </td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
                        <div class="flex gap-1 items-center">
                          @if (taSubmission.travellerCount > 1) {
                            <i class="fa-solid fa-users"></i>
                          } @else {
                            <i class="fa-solid fa-user"></i>
                          }
                          <span class="text-nowrap">{{taSubmission.primaryTraveller?.details?.name}}</span>
                        </div>
                      </td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.travellerCount}}</td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.projectCode}}</td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 2px 4px;"><ta-cost-bubble severity="outlined" [tableVersion]="true" [value]="taSubmission.currentValue ?? taSubmission.originalValue ?? 0"></ta-cost-bubble></td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 2px 4px;"><ta-cost-bubble severity="danger" [tableVersion]="true" [value]="taOverpaidAmount(taSubmission)"></ta-cost-bubble></td>
                      <td class="ta-col-actions" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 6px;">
                        <div class="flex flex-col justify-start">
                          <p-button [style]="{height:'1.8em'}" [text]="true" severity="primary" size="small" (onClick)="setSelectedTa(taSubmission); $event.stopPropagation()"><span class="text-nowrap">View Summary</span></p-button>
                          <p-button [style]="{height:'1.8em'}" [text]="true" severity="primary" size="small" (onClick)="viewTaSubmission(taSubmission)"><span class="text-nowrap">Review Full TA</span></p-button>
                        </div>
                      </td>
                      <td class="ta-col-comments" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-br-lg' : (rowIndex === availableTaList().length - 1)}">
                        <ta-comment-count [count]="taSubmission.commentCount"></ta-comment-count>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template #footer>
                    @if (filteredTaList().length === 0) {
                      <tr class="text-xs font-normal font-['Roboto_Condensed']">
                        <td class="rounded-bl-lg rounded-br-lg" colspan="12"><i>No results.</i></td>
                      </tr>
                    }
                  </ng-template>
                </p-table>
              } @else {
                <div class="self-stretch justify-start text-slate-500 text-sm font-normal font-['Inter'] leading-6">No overpaid TAs requiring action.</div>
              }
            </div>
          </p-tabpanel>

          <p-tabpanel value="dayTrips">
            <div scrollHeight [bottomPadding]="60" class="flex flex-col gap-4 overflow-auto">
              @if (availableTaList().length > 0) {
                <div class="flex gap-2 items-center">
                  @if (selectedCount() > 0) {
                    <p-button size="small" label="Process Day Trip Payments" data-testid="process-selected-day-trips" (onClick)="processSelectedDayTripPaymentsClicked()"></p-button>
                  } @else {
                    <input type="text"
                         pInputText
                         [(ngModel)]="searchStr"
                         class="w-1/2"
                         pSize="small"
                         placeholder="Type to filter by TA number, project code, status or staff..."
                    />
                    <div class="bg-white rounded-lg">
                      <p-button outlined severity="secondary"
                            size="small"
                            (onClick)="searchStr.set('')">Clear</p-button>
                    </div>
                  }
                </div>

                <p-table [value]="filteredTaList()"
                     stripedRows
                     [tableStyle]="{'min-width': '40rem'}"
                     sortField="taNumber"
                     [sortOrder]="-1"
                     class="ta-list ta-list-dense border-[1px] border-surface-300 rounded-lg">
                  <ng-template #header>
                    <tr class="text-datatable-header-cell-color text-xs font-semibold font-['Roboto_Condensed']">
                      @if (dayTripBatchEnabled) {
                        <th class="rounded-tl-lg w-8">
                          @if (canProcessDayTripPayment()) {
                            <p-checkbox [binary]="true" size="small"
                                        [ngModel]="allFilteredSelected()"
                                        (onChange)="setAllFilteredSelected($event.checked)"
                                        [attr.data-testid]="'select-all-tas'" />
                          }
                        </th>
                      }
                      <th [ngClass]="{'rounded-tl-lg': !dayTripBatchEnabled}">TA Number</th>
                      <th pSortableColumn="startDate" style="align-items: center">
                        <div class="flex items-center gap-2">
                          Travel Date
                          <p-sortIcon field="startDate" />
                        </div>
                      </th>
                      <th>Status</th>
                      <th>Primary Traveller</th>
                      <th>No. of Travellers</th>
                      <th>Project Code</th>
                      <th style="padding-left: 4px; padding-right: 4px; text-align: center;">Total TA Value (Acquitted)</th>
                      <th style="padding-left: 4px; padding-right: 4px; text-align: center;">Day Trip Component</th>
                      <th class="ta-col-actions">Actions</th>
                      <th class="rounded-tr-lg ta-col-comments"></th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-taSubmission let-rowIndex="rowIndex">
                    <tr class="text-xs font-normal font-['Roboto_Condensed'] hover:cursor-pointer" (click)="setSelectedTa(taSubmission)">
                      @if (dayTripBatchEnabled) {
                        <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-bl-lg' : (rowIndex === availableTaList().length - 1)}"
                            (click)="$event.stopPropagation()">
                          @if (canProcessDayTripPayment()) {
                            <p-checkbox [binary]="true" size="small"
                                        [ngModel]="isSelected(taSubmission)"
                                        (onChange)="setSelected(taSubmission, $event.checked)"
                                        [attr.data-testid]="'select-ta-' + taSubmission.taNumber" />
                          }
                        </td>
                      }
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-bl-lg' : !dayTripBatchEnabled && (rowIndex === availableTaList().length - 1)}">
                        <button class="text-primary-500 hover:underline font-semibold cursor-pointer" (click)="viewTaSubmission(taSubmission)">
                          {{taSubmission.taNumber}}
                        </button>
                      </td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.startDate | date:'dd/MM/yy'}}</td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
                        <p-chip>
                          <div class="whitespace-nowrap">{{dayTripStatusText(taSubmission.status)}}</div>
                        </p-chip>
                      </td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">
                        <div class="flex gap-1 items-center">
                          @if (taSubmission.travellerCount > 1) {
                            <i class="fa-solid fa-users"></i>
                          } @else {
                            <i class="fa-solid fa-user"></i>
                          }
                          <span class="text-nowrap">{{taSubmission.primaryTraveller?.details?.name}}</span>
                        </div>
                      </td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.travellerCount}}</td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}">{{taSubmission.projectCode}}</td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 2px 4px;"><ta-cost-bubble severity="outlined" [tableVersion]="true" [value]="taSubmission.currentValue ?? taSubmission.originalValue ?? 0"></ta-cost-bubble></td>
                      <td [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 2px 4px;"><ta-cost-bubble severity="purple" [tableVersion]="true" [value]="taPaymentComponents(taSubmission).dayTrip"></ta-cost-bubble></td>
                      <td class="ta-col-actions" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id)}" style="padding: 6px;">
                        <div class="flex flex-col justify-start">
                          <p-button [style]="{height:'1.8em'}" [text]="true" severity="primary" size="small" (onClick)="viewTaSubmission(taSubmission)"><span class="text-nowrap">Review Full TA</span></p-button>
                          @if (canProcessDayTripPayment()) {
                            <p-button [style]="{height:'1.8em'}" [text]="true" severity="primary" size="small" [attr.data-testid]="'process-day-trip-' + taSubmission.taNumber" (onClick)="processDayTripPaymentClicked(taSubmission); $event.stopPropagation()"><span class="text-nowrap">Process Day Trip Payment</span></p-button>
                          }
                        </div>
                      </td>
                      <td class="ta-col-comments" [ngClass]="{'bg-primary-50': (taSubmission.id === store.taSubmission()?.id), 'rounded-br-lg' : (rowIndex === availableTaList().length - 1)}">
                        <ta-comment-count [count]="taSubmission.commentCount"></ta-comment-count>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template #footer>
                    @if (filteredTaList().length === 0) {
                      <tr class="text-xs font-normal font-['Roboto_Condensed']">
                        <td class="rounded-bl-lg rounded-br-lg" [attr.colspan]="dayTripBatchEnabled ? 11 : 10"><i>No results.</i></td>
                      </tr>
                    }
                  </ng-template>
                </p-table>
              } @else {
                <div class="self-stretch justify-start text-slate-500 text-sm font-normal font-['Inter'] leading-6">No day trip payments requiring action.</div>
              }
            </div>
          </p-tabpanel>

          @if (permissionService.canViewSearch()) {
            <p-tabpanel value="allSubmissions">
              @if (tabOption === 'allSubmissions') {
                <all-submissions-search></all-submissions-search>
              }
            </p-tabpanel>
          }
        </p-tabpanels>
      </p-tabs>
    </p-card>
    <div class="p-2.5 w-full"></div>
  </div>
  <div class="flex flex-col gap-6 max-w-1/4 w-fit">
    <ta-info-card [selectedTa]="selectedTa()"
                  [viewOnly]="tabOption !== 'dayTrips'"
                  [infoContext]="tabOption === 'dayTrips' ? 'compliance' : undefined"
                  [costView]="tabOption === 'overpaid' ? 'overpaid' : tabOption === 'dayTrips' ? 'dayTrip' : undefined"
                  (actionTa)="taActionClicked($event)"></ta-info-card>
  </div>
</div>
